<template><section><h3>图表介绍</h3>
<p>Line Chart, 折线图。</p>
<h3>属性 attrs</h3>
<p>通过设置 Line 的属性来产生不同的样式，包含若干属性</p>
<table>
<thead>
<tr>
<th>属性名</th>
<th>类型</th>
<th>默认值</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>clientRect</td>
<td>Object</td>
<td>{top,right,bottom,left,width,height}</td>
<td>设置了 width,heigh,优先与 bottom,right</td>
</tr>
<tr>
<td>smooth</td>
<td>Boolean</td>
<td>false</td>
<td>曲线是否平滑</td>
</tr>
<tr>
<td>axisGap</td>
<td>Boolean</td>
<td>false</td>
<td>开始绘图区域与坐标轴是否有间隙</td>
</tr>
<tr>
<td>splitNumber</td>
<td>Number</td>
<td>0</td>
<td>坐标轴的分割段数，用来计算线的最大高度，在设置坐标轴的 splitNumber 属性时同步加上</td>
</tr>
</tbody>
</table>
<h3>style 属性</h3>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> line = <span class="hljs-keyword">new</span> Line({ <span class="hljs-attr">smooth</span>: <span class="hljs-literal">true</span> })
line.style(<span class="hljs-string">'point'</span>, { <span class="hljs-attr">pointType</span>: <span class="hljs-string">'star'</span>, <span class="hljs-attr">size</span>: <span class="hljs-number">8</span> })
</code></pre>
<p>组件中可以自定义 css 属性的元素如下表：</p>
<table>
<thead>
<tr>
<th>名称</th>
<th>基础类型</th>
<th>描述</th>
</tr>
</thead>
<tbody>
<tr>
<td>guideline</td>
<td>线</td>
<td>指导线样式</td>
</tr>
<tr>
<td>line</td>
<td>线</td>
<td>线条样式</td>
</tr>
<tr>
<td>point</td>
<td>面，除了基础面的全部属性外，还有(<a style="text-decoration:underline" href="./#/doc/plugin/Point">Point</a>)的特殊属性</td>
<td>线条上标记点样式</td>
</tr>
<tr>
<td>point:hover</td>
<td>面，除了基础面的全部属性外，还有(<a style="text-decoration:underline" href="./#/doc/plugin/Point">Point</a>)的特殊属性</td>
<td>hover 时线条上标记点样式</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>